export default "{{$ctrl.duration_formatted}}";